// src/utils/buildPlayerAvailability.js
// Costruisce la mappa di disponibilità dei giocatori (infortuni + probabili
// formazioni) usata dal motore scambi per segnalare/retrocedere i pacchetti
// che ti portano un infortunato o un panchinaro fisso.
//
// Sorgenti (entrambe già in casa, nessuna nuova API):
//  - getCurrentInjuriesByName(): mappa infortuni Serie A (sync FantaMaster)
//  - getLineupStatusByPlayerId(): stato "titolare/panchina" dalle probabili
//    formazioni (cache client-side 3h)
import { getCurrentInjuriesByName, normalizeInjuryKey } from '../firebase/injuriesService';
import { getLineupStatusByPlayerId } from '../firebase/playerService';

// players: lista di { id, name } (dataset o snapshot degli acquisti).
// Ritorna Map(playerId -> { injury?: {reason, expectedReturn, severity},
//                           lineup?: {status:'starter'|'bench', prob} }).
export async function buildPlayerAvailability(players = []) {
  const list = (players || []).filter((p) => (p?.id ?? p?.playerId) && p?.name);
  if (!list.length) return new Map();

  const [injByName, lineup] = await Promise.all([
    getCurrentInjuriesByName().catch(() => new Map()),
    getLineupStatusByPlayerId(list.map((p) => ({ id: String(p.id ?? p.playerId), name: p.name })))
      .catch(() => ({ byId: {} })),
  ]);

  const byId = new Map();
  list.forEach((p) => {
    const id = String(p.id ?? p.playerId);
    const entry = {};

    const inj = injByName.get(normalizeInjuryKey(p.name || ''));
    if (inj) {
      entry.injury = {
        reason: inj.reason || 'infortunato',
        expectedReturn: inj.expectedReturn || null,
        severity: Number.isFinite(Number(inj.severity)) ? Number(inj.severity) : null,
      };
    }

    const lu = lineup?.byId?.[id];
    if (lu && (lu.status === 'starter' || lu.status === 'bench')) {
      entry.lineup = { status: lu.status, prob: lu.prob ?? null };
    }

    if (entry.injury || entry.lineup) byId.set(id, entry);
  });

  return byId;
}
